import { useState } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
// import ScenePage from './pages/scene/scene.component';
import ControllerPage from './pages/controller/controller.component';



function App() {
  const [sharedState, setSharedState] = useState("");
  return (

    <Router>
      <Routes>
        <Route path="/" element={<ControllerPage sharedState={sharedState} setSharedState={setSharedState}/>} />
      </Routes>
    </Router>

  );
}

export default App;
